import { PlanogramSubcomponent } from './PlanogramSubcomponent.js';
import {PegAttributes} from './Resources.js';

export class PlanogramPeg extends HTMLElement{

    //#region Attributes
    static PegAttributes = PegAttributes.PegAttributes;
    //#endregion

    static get observedAttributes() {
        return [ ...Object.values(PlanogramPeg.PegAttributes) ];
    }

    //#region Attribute Properties
    get x() { return Number(this.getAttribute(PlanogramPeg.PegAttributes.X)) || 0; }
    get y() { return Number(this.getAttribute(PlanogramPeg.PegAttributes.Y)) || 0; }
    get depth() { return Number(this.getAttribute(PlanogramPeg.PegAttributes.Depth)) || 0; }
    get tagWidth() { return Number(this.getAttribute(PlanogramPeg.PegAttributes.TagWidth)) || 0; }
    get tagHeight() { return Number(this.getAttribute(PlanogramPeg.PegAttributes.TagHeight)) || 0; }
    get tagXOffset() { return Number(this.getAttribute(PlanogramPeg.PegAttributes.TagXOffset)) || 0; }
    get tagYOffset() { return Number(this.getAttribute(PlanogramPeg.PegAttributes.TagYOffset)) || 0; }
    get upperStart() { return Number(this.getAttribute(PlanogramPeg.PegAttributes.UpperStart)) || 0; }
    get drawUpper() { return this.hasAttribute(PlanogramPeg.PegAttributes.DrawUpper); }
    get drawTag() { return this.hasAttribute(PlanogramPeg.PegAttributes.DrawTag); }
    //#endregion

    //#region Private Properties
    firstRender = true;
    #parentSubComponent = null;
    //#endregion

    constructor() { super(); }

    //#region Web Component Lifecycle

    connectedCallback() {
        if(this.parentElement instanceof PlanogramSubcomponent && this.parentElement.hasPegHoles){
            this.#parentSubComponent = this.parentElement;
            this.firstRender = false;
            this.#parentSubComponent.pegsPlug();
        }else{
            this.remove();
        }    
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (this.firstRender || oldValue === newValue) return;
        this.#parentSubComponent.pegsPlug();
    }

    disconnectedCallback() { if(this.#parentSubComponent)this.#parentSubComponent.pegsPlug(); }
    //#endregion
}